import { Link } from "react-router-dom";
import styles from "../styles/QuickInfo.module.css";

export default function QuickInfo() {
  return (
    <section className={styles.section}>
      <div className="container">
        <header className={styles.header}>
          <h2 className={styles.kicker}>About Me</h2>
          <div className={styles.rule} />
        </header>

        <div className={styles.grid}>
          <div className="photoCard">
            <img
              className="photo"
              src="/images/profile.jpg"
              alt="Portrait of Krzysztof Chabowski"
            />
          </div>

          <div className={styles.content}>
            <h3 className={styles.title}>
              Hi, I'm{" "}
              <span className={styles.name}>Krzysztof M. Chabowski</span>.
            </h3>

            <p className={styles.text}>
              I create user-friendly apps for learning and data management.
            </p>
            <p className={styles.text}>
              Passionate about building tools that help others.
            </p>

            <Link className={styles.more} to="/about">
              Read More
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
